if (typeof FreeGiftNotice !== 'function') {

  class FreeGiftNotice extends HTMLElement {

    constructor() {
      super();
      // Delay initialization to ensure all globals are loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      try {
        // Free gift threshold: Rs.2500 = 250000 paise (Shopify stores in smallest currency unit)
        const thresholdAttr = this.getAttribute('data-free-gift-threshold');
        if (!thresholdAttr) return;

        // Handle currency conversion safely
        let currencyRate = 1;
        if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
          currencyRate = Number(Shopify.currency.rate);
        }

        const freeGiftThreshold = Math.round(Number(thresholdAttr) * currencyRate);
        const cartTotal = Number(this.getAttribute('data-cart-total')) || 0;
        const amountRemaining = freeGiftThreshold - cartTotal;

        let progressWidth = 0;
        const textElement = this.querySelector('[data-js-free-gift-text]');
        const sliderElement = this.querySelector('[data-js-free-gift-slider]');
        const giftIcon = this.querySelector('[data-js-gift-icon]');

        if (!textElement) return;

        if (amountRemaining > 0) {
          // Customer still needs to spend more
          const formattedAmount = this._formatMoney(amountRemaining);
          textElement.innerHTML = `You are <strong>${formattedAmount}</strong> away from your <strong>FREE GIFT!</strong> 🎁`;
          progressWidth = ((freeGiftThreshold - amountRemaining) / freeGiftThreshold) * 100;
          this.classList.remove('free-gift--achieved');
          if (giftIcon) giftIcon.classList.remove('gift-icon--bounce');
        } else {
          // Customer qualifies for free gift
          textElement.innerHTML = `🎉 <strong>Congratulations!</strong> You got the <strong>FREE GIFT!</strong> 🎁`;
          progressWidth = 100;
          this.classList.add('free-gift--achieved');
          if (giftIcon) giftIcon.classList.add('gift-icon--bounce');
        }

        if (sliderElement) {
          sliderElement.style.width = `${progressWidth}%`;
        }
      } catch (error) {
        console.warn('FreeGiftNotice initialization error:', error);
      }
    }

    _formatMoney(cents) {
      try {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        // Get money format from KROWN settings or use default
        let format = 'Rs.{{amount}}';
        if (typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.shop_money_format) {
          format = KROWN.settings.shop_money_format;
        }

        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholderRegex);

        if (!match) {
          // Fallback if no placeholder found
          return 'Rs.' + (cents / 100).toFixed(0);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
          );
          const centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
        }

        switch (match[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
          default:
            value = formatWithDelimiters(cents, 0);
        }

        return format.replace(placeholderRegex, value);
      } catch (error) {
        console.warn('FreeGiftNotice formatMoney error:', error);
        return 'Rs.' + Math.round(cents / 100);
      }
    }

  }

  if (typeof customElements.get('free-gift-notice') == 'undefined') {
    customElements.define('free-gift-notice', FreeGiftNotice);
  }

}
